import React from 'react';

import { locale } from '@trqk/utils';
import { IconInfoCircle } from '@trqk/components';

interface PerformancesEmptyStateProps {
    height: number;
    width: number;
}

export const PerformancesEmptyState = ({
    height,
    width,
}: PerformancesEmptyStateProps): JSX.Element => (
        <div
            className="flex justify-center items-center"
            style={{ height, width }}
        >
            <div className="flex items-center">
                <IconInfoCircle addClasses="mr-2" />
                <div className="text-tertiary-400 italic">
                    {locale.enUS.STATEMENTS.PERFORMANCES.NO_PERFORMANCE_DATA}
                </div>
            </div>
        </div>
    );
